export default{
    
    lista:{
        method:'get',
        url:'boletins/cartaoponto/lista'
    },
    cadastra:{
        method:'post',
        url:'boletins/cartaoponto/cadastro'
    },
    delete:{
        method:'delete',
        url:'boletins/cartaoponto/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'boletins/cartaoponto/editar{/id}'
    },
    update:{
        method:'post',
        url:'boletins/cartaoponto/update'
    },
    configuracaocartaoponto:{
        method:'post',
        url:'tabelapreco/configuracao/cartaoponto/show'
    }
}